// Left Section ---------------------------------------------
var VoucherDescHeadContainer;
var VoucherDescHeaderText;
var VoucherDescriptionTextContainer;
var VoucherDescriptionText;
var VoucherDescriptionLoadingContainer;

var SyaratKetentuanHeaderText;
var SyaratKetentuanListContainer;

var CaraPakaiHeaderText;
var CaraPakaiTextContainer;

// Right Section ---------------------------------------------

var FlagVoucherTypeText;

var VoucherInfoContainerWrapper;

var VoucherCodeContainer;
var KodeVoucherHeaderText;
var KodeVoucherKodeText;

var VoucherDetailsOrangeBtn;
var VoucherDetailsOrangeBtnContentWrapper;
var VoucherDetailsOrangeBtnIcon;
var VoucherDetailsOrangeBtnText;

// Not Found ---------------------------------------------

var VoucherAllMainSectionContainer;
var NoVoucherFoundContainer;

// ========================================= PREPARE ELEMENTS ===========================================

window.PrepareVoucherDetails = function()
{
    document.getElementById("WhichPageSectionIsText").innerHTML = window["VoucherDetailsTxt" + window.CurrentCountryID];

    // Left Section ---------------------------------------------

    document.getElementById("VoucherDescHeaderText").innerHTML = window["DeskripsiVoucTxt" + window.CurrentCountryID];
    
    document.getElementById("SyaratKetentuanHeaderText").innerHTML = window["TermsNCondition2Txt" + window.CurrentCountryID];
    
    document.getElementById("CaraPakaiHeaderText").innerHTML = window["HowtoUseTxt" + window.CurrentCountryID];


    // Right Section ---------------------------------------------

    document.getElementById("KodeVoucherHeaderText").innerHTML = window["VoucherCodeTxt" + window.CurrentCountryID];


    // Not Found ---------------------------------------------

    document.getElementById("NoVoucherFoundHeaderText").innerHTML = window["OopsNoVoucherTxt" + window.CurrentCountryID];
    document.getElementById("NoVoucherFoundMessageText").innerHTML = window["VoucherThatYouTriedToLoadNotExistTxt" + window.CurrentCountryID];
}

window.AssignAllVariableVoucherDetails = function(MainSession, loggedin)
{
    // Left Section ---------------------------------------------

    VoucherDescHeadContainer = document.getElementById("VoucherDescHeadContainer");
    VoucherDescHeaderText = document.getElementById("VoucherDescHeaderText");
    VoucherDescriptionTextContainer = document.getElementById("VoucherDescriptionTextContainer");
    VoucherDescriptionText = document.getElementById("VoucherDescriptionText");
    VoucherDescriptionLoadingContainer = document.getElementById("VoucherDescriptionLoadingContainer");

    SyaratKetentuanHeaderText = document.getElementById("SyaratKetentuanHeaderText");
    SyaratKetentuanListContainer = document.getElementById("SyaratKetentuanListContainer");

    CaraPakaiHeaderText = document.getElementById("CaraPakaiHeaderText");
    CaraPakaiTextContainer = document.getElementById("CaraPakaiTextContainer");

    // Right Section ---------------------------------------------

    FlagVoucherTypeText = document.getElementById("FlagVoucherTypeText");

    VoucherInfoContainerWrapper = document.getElementById("VoucherInfoContainerWrapper");

    VoucherCodeContainer = document.getElementById("VoucherCodeContainer");
    KodeVoucherHeaderText = document.getElementById("KodeVoucherHeaderText");

    KodeVoucherKodeText = document.getElementById("KodeVoucherKodeText");

    VoucherDetailsOrangeBtn = document.getElementById("VoucherDetailsOrangeBtn");
    VoucherDetailsOrangeBtnContentWrapper = document.getElementById("VoucherDetailsOrangeBtnContentWrapper");
    VoucherDetailsOrangeBtnIcon = document.getElementById("VoucherDetailsOrangeBtnIcon");
    VoucherDetailsOrangeBtnText = document.getElementById("VoucherDetailsOrangeBtnText");

    // Not Found ---------------------------------------------

    VoucherAllMainSectionContainer = document.getElementById("VoucherAllMainSectionContainer");

    NoVoucherFoundContainer = document.getElementById("NoVoucherFoundContainer");

    LoadVoucherDetails(MainSession, loggedin);
}


// ========================================= LOAD VOUCHER DETAILS ===========================================

function LoadVoucherDetails(MainSession, loggedin)
{
    let CurrentUrl = new URL(window.location.href);
    let VoucherID = CurrentUrl.searchParams.get("id_voucher");
    let RewardType = CurrentUrl.searchParams.get("reward_type");

    if(loggedin == true && VoucherID != null && RewardType != null)
    {
        let WhichTypeForUrl = "in_app";
        let WhichTypeCurrent = "Voucher PinginGo";
        let MyVoucherURLLoad = "/v2/vouchers/in-app/" + VoucherID;
        let HowManyInfo = 2;

        if(parseInt(RewardType) == 2)
        {
            WhichTypeForUrl = "partner";
            WhichTypeCurrent = "Voucher Partner";
            MyVoucherURLLoad = "/v2/vouchers/partner/" + VoucherID;
            HowManyInfo = 4;
            VoucherCodeContainer.remove();
            VoucherDetailsOrangeBtnIcon.src = "/Assets/images/ButtonIcon/white-message-chat.svg";
            VoucherDetailsOrangeBtnText.innerHTML = window["ContactCustomerSerTxt" + window.CurrentCountryID];
        }
        else if(parseInt(RewardType) == 3)
        {
            WhichTypeForUrl = "gift";
            WhichTypeCurrent = "Gift";
            MyVoucherURLLoad = "/v2/vouchers/gift/" + VoucherID;
            VoucherCodeContainer.remove();
            VoucherDetailsOrangeBtnIcon.src = "/Assets/images/ButtonIcon/white-message-chat.svg";
            VoucherDetailsOrangeBtnText.innerHTML = window["ContactCustomerSerTxt" + window.CurrentCountryID];
        }
        else
        {
            VoucherDetailsOrangeBtnText.innerHTML = window["SalinKodeVoucTxt" + window.CurrentCountryID];
        }

        FlagVoucherTypeText.innerHTML = WhichTypeCurrent;
        
        // Loading Info Voucher Right --------------------------------------
        
        VoucherInfoContainerWrapper.innerHTML = "";

        for(let i = 0; i < HowManyInfo; i++)
        {
            let TglClaimContainer = document.createElement("div");
            TglClaimContainer.className = "PoinWithIconWrapper PoinWithIconWrapperDetails BasicChildMargin2 InputFieldMargin4";
            VoucherInfoContainerWrapper.append(TglClaimContainer);

            let TglClaimSmallWrapper = document.createElement("div");
            TglClaimSmallWrapper.className = "RewardInfoSmallWrapper";
            TglClaimContainer.append(TglClaimSmallWrapper);

            let TglClaimHeaderText = document.createElement("p");
            TglClaimHeaderText.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey2";
            TglClaimHeaderText.style.color = "transparent";
            TglClaimHeaderText.style.width = "fit-content";
            TglClaimHeaderText.innerHTML = "Test Text:";
            TglClaimSmallWrapper.append(TglClaimHeaderText);

            let TglClaimInfoText = document.createElement("p");
            TglClaimInfoText.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey2";
            TglClaimInfoText.style.marginLeft = "auto";
            TglClaimInfoText.style.width = "fit-content";
            TglClaimInfoText.style.color = "transparent";
            TglClaimInfoText.innerHTML = "Test Value";
            TglClaimSmallWrapper.append(TglClaimInfoText);
        }

        // Load Info ------------------------------------------------------------

        let FinalUrlLoadVoucherDetails = MyVoucherURLLoad + "?id_user=" + MainSession.usd_PING_id + "&lang=" + window.CurrentCountryID;
        //console.log(FinalUrlLoadVoucherDetails);
        
        window.CallApiAxios({
            method: "GET",
            url: FinalUrlLoadVoucherDetails
        }).then(res =>
        {
            //console.log(res);
            let VoucherDetailData = res.data.data[0];
            //console.log(VoucherDetailData);
            
            document.getElementById("FlagVoucherMain").style.display = "";

            // Description ----------------------------
            if(VoucherDetailData.voucher_description != null && VoucherDetailData.voucher_description != "")
            {
                let ThisVoucherDesc = window.decodeGarbledContent(VoucherDetailData.voucher_description);
                VoucherDescriptionTextContainer.style.display = ""; // Description
                VoucherDescriptionText.innerHTML = ThisVoucherDesc;
            }
            else
            {
                VoucherDescHeadContainer.remove();
                VoucherDescriptionTextContainer.remove();
            }
            VoucherDescriptionLoadingContainer.remove();

            // Terms and Condition ----------------------------

            InstantiateTermsCondition(VoucherDetailData.term_condition); 

            // How to Use ----------------------------

            LoadCaraPakaiText(WhichTypeForUrl);

            // Instantiate Right Small Info  ----------------------------

            InstantiateVoucherRightInfo(VoucherDetailData, WhichTypeForUrl);
        })
        .catch(err =>
        {
            //console.error(err);
            NoVoucherFoundContainer.style.display = "";
            VoucherAllMainSectionContainer.remove();
        });
    }
    else
    {
        NoVoucherFoundContainer.style.display = "";
        VoucherAllMainSectionContainer.remove();
    }
}


// =============================== TERMS CONDITION ====================================

function InstantiateTermsCondition(TermList)
{
    if(TermList != null)
    {
        SyaratKetentuanListContainer.innerHTML = '';

        let TermArray = TermList.split(/\r?\n/);

        for(let i = 0; i < TermArray.length; i++)
        {
            if(TermArray[i] != ""  && TermArray[i].replace(/ /g, "") !="")
            {
                let TermsLi = document.createElement("li");
                TermsLi.className = "BasicAlphaNumberLi";
                SyaratKetentuanListContainer.append(TermsLi);

                let BasicListContentWrapper = document.createElement("div");
                BasicListContentWrapper.className = "BasicListContentWrapper";
                TermsLi.append(BasicListContentWrapper);
        
                let TermsInfoText = document.createElement("p");
                TermsInfoText.className = "DescriptionTextNotDisableable InterMediumTextFont";
                TermsInfoText.innerHTML = TermArray[i];
                BasicListContentWrapper.append(TermsInfoText);
            }
        }
    }
    else
    {
        let SyaratKetentuanSection = document.querySelectorAll(".SyaratKetentuanSection");
        SyaratKetentuanSection.forEach(ThisElement =>
        {
            ThisElement.remove();
        });
    }
}


// =============================== LOAD HOW TO =======================================

function LoadCaraPakaiText(whichtype)
{
    CaraPakaiTextContainer.innerHTML = "";

    let WhichHowTo = window["HowToUse" + whichtype];

    for(let i = 0; i < WhichHowTo.length; i++)
    {
        let NumberCounterLi = document.createElement("li");
        NumberCounterLi.className = "BasicAlphaNumberLi";
        CaraPakaiTextContainer.append(NumberCounterLi);

        let BasicListContentWrapper = document.createElement("div");
        BasicListContentWrapper.className = "BasicListContentWrapper";
        NumberCounterLi.append(BasicListContentWrapper);

        let DescriptionTextNotDisableable = document.createElement("p");
        DescriptionTextNotDisableable.className = "DescriptionTextNotDisableable InterMediumTextFont";
        DescriptionTextNotDisableable.innerHTML = WhichHowTo[i][window.CurrentCountryID];
        BasicListContentWrapper.append(DescriptionTextNotDisableable);
    }

}

// ================================= INSTIATE VOUCHER RIGHT ================================

function InstantiateVoucherRightInfo(voucherdetails, whichtype)
{
    document.getElementById("VoucherNameText").innerHTML = voucherdetails.voucher_name;
    document.getElementById("VoucherNameText").style.opacity = 1;

    // -------------------------------------- Voucher Image --------------------------------------

    let ImageElementToCheck = [];

    let VoucherImageContainer = document.getElementById("VoucherImageContainer");
    
    let VoucherImage = document.createElement("img");
    VoucherImage.className = "ImageFullCover";
    VoucherImageContainer.append(VoucherImage);

    ImageElementToCheck.push(VoucherImage);

    window.checkImageUrlValid(voucherdetails.image_link, "/Assets/images/NoHotelImage.jpg", VoucherImage, () =>
    {
        window.HandleAllImageLoadWithFunction(ImageElementToCheck, function()
        {
            VoucherImageContainer.className = "VoucherImageContainer BasicRoundRadius";
        })
    }, { quality: 70});

    // -------------------------------------- Voucher Name --------------------------------------

    document.getElementById("VoucherNameText").className = "LabelGreyHeaderSmallerText2 InterBoldTextFont";
    document.getElementById("VoucherNameText").style.color = "";
    document.getElementById("VoucherNameText").innerHTML = voucherdetails.voucher_name;

    // -------------------------------------- Voucher Information ----------------------------------
    
    VoucherInfoContainerWrapper.innerHTML = "";
    // Tanggal Claim ---------------------------------------------------------
    
    if(whichtype == "gift" || whichtype == "partner")
    {
        let TglClaimContainer = document.createElement("div");
        TglClaimContainer.className = "PoinWithIconWrapper PoinWithIconWrapperDetails BasicChildMargin2 InputFieldMargin4";
        VoucherInfoContainerWrapper.append(TglClaimContainer);

        let TglClaimIcon = document.createElement("img");
        TglClaimIcon.style.marginLeft = 0;
        TglClaimIcon.src = "/Assets/images/ButtonIcon/clock-icon-orange.svg";
        TglClaimContainer.append(TglClaimIcon);

        let TglClaimSmallWrapper = document.createElement("div");
        TglClaimSmallWrapper.className = "RewardInfoSmallWrapper";
        TglClaimContainer.append(TglClaimSmallWrapper);

        let TglClaimHeaderText = document.createElement("p");
        TglClaimHeaderText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        TglClaimHeaderText.style.color = "#797979";
        TglClaimHeaderText.innerHTML = window["ClaimDateTxt" + window.CurrentCountryID];
        TglClaimSmallWrapper.append(TglClaimHeaderText);

        let TglClaimInfoText = document.createElement("p");
        TglClaimInfoText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        TglClaimInfoText.style.marginLeft = "auto";
        TglClaimSmallWrapper.append(TglClaimInfoText);

        if(voucherdetails.claimed_date != null && voucherdetails.claimed_date != "")
        {
            let ThisVoucherClaimedDateTimeArray = voucherdetails.claimed_date.split(" ");

            let ThisVoucherClaimedDateArray = ThisVoucherClaimedDateTimeArray[0].split("-");
            let VoucherClaimedYear = ThisVoucherClaimedDateArray[0];
            let VoucherClaimedMonth = ThisVoucherClaimedDateArray[1];
            let VoucherClaimedDate = ThisVoucherClaimedDateArray[2];

            let ThisVoucherClaimedTimeArray = ThisVoucherClaimedDateTimeArray[1].split(":");
            let VoucherClaimedHour = ThisVoucherClaimedTimeArray[0];
            let VoucherClaimedMin = ThisVoucherClaimedTimeArray[1];

            TglClaimInfoText.innerHTML = VoucherClaimedDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherClaimedMonth) - 1] + " " + VoucherClaimedYear + ", " + VoucherClaimedHour + ":" + VoucherClaimedMin;
        }
        else
        {
            TglClaimInfoText.innerHTML = window["NoClaimDateTxt" + window.CurrentCountryID];
        }
    }
    
    // Berlaku Tanggal ---------------------------------------------------------

    if(whichtype == "in_app" || whichtype == "partner")
    {
        let BerlakuSDContainer = document.createElement("div");
        BerlakuSDContainer.className = "PoinWithIconWrapper PoinWithIconWrapperDetails BasicChildMargin2 InputFieldMargin4";
        VoucherInfoContainerWrapper.append(BerlakuSDContainer);

        let BerlakuSDIcon = document.createElement("img");
        BerlakuSDIcon.style.marginLeft = 0;
        BerlakuSDIcon.src = "/Assets/images/ButtonIcon/clock-icon-orange.svg";
        BerlakuSDContainer.append(BerlakuSDIcon);

        let BerlakuSDSmallWrapper = document.createElement("div");
        BerlakuSDSmallWrapper.className = "RewardInfoSmallWrapper";
        BerlakuSDContainer.append(BerlakuSDSmallWrapper);

        let BerlakuSDHeaderText = document.createElement("p");
        BerlakuSDHeaderText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        BerlakuSDHeaderText.style.color = "#797979";
        BerlakuSDHeaderText.innerHTML =  window["BerlakuSDTxt" + window.CurrentCountryID];
        BerlakuSDSmallWrapper.append(BerlakuSDHeaderText);

        let BerlakuSDInfoText = document.createElement("p");
        BerlakuSDInfoText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        BerlakuSDInfoText.style.marginLeft = "auto";
        BerlakuSDSmallWrapper.append(BerlakuSDInfoText);

        let ThisStartDate = voucherdetails.valid_from;
        if(voucherdetails.start_date != null)
            ThisStartDate = voucherdetails.start_date;

        let ThisEndDate = voucherdetails.valid_until;
        if(voucherdetails.end_date != null)
            ThisEndDate = voucherdetails.end_date;

        if(ThisEndDate != null && ThisEndDate != "")
        {
            let ThisVoucherStartDateArray = ThisStartDate.split("-");

            let VoucherStartYear = ThisVoucherStartDateArray[0];
            let VoucherStartMonth = ThisVoucherStartDateArray[1];
            let VoucherStartDate = ThisVoucherStartDateArray[2];

            let ThisVoucherDeadlineArray = ThisEndDate.split("-");
            let VoucherEndYear = ThisVoucherDeadlineArray[0];
            let VoucherEndMonth = ThisVoucherDeadlineArray[1];
            let VoucherEndDate = ThisVoucherDeadlineArray[2];

            if(whichtype == "partner")
            {
                BerlakuSDInfoText.innerHTML = VoucherEndDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherEndMonth) - 1] + " " + VoucherEndYear;
            }
            else
            {
                BerlakuSDInfoText.innerHTML = VoucherStartDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherStartMonth) - 1] + " " + VoucherStartYear + " - " + VoucherEndDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherEndMonth) - 1] + " " + VoucherEndYear;
            }
        }
        else
        {
            BerlakuSDInfoText.innerHTML = window["NoExpDateTxt" + window.CurrentCountryID];
        }
    }
    
    // Min Transaksi ---------------------------------------------------------

    //console.log(voucherdetails.min_transaction);
    //console.log(whichtype);

    if(whichtype == "in_app" || whichtype == "partner")
    {
        let MinTransContainer = document.createElement("div");
        MinTransContainer.className = "PoinWithIconWrapper PoinWithIconWrapperDetails BasicChildMargin2 InputFieldMargin4";
        VoucherInfoContainerWrapper.append(MinTransContainer);

        let MinTransIcon = document.createElement("img");
        MinTransIcon.style.marginLeft = 0;
        MinTransIcon.src = "/Assets/images/ButtonIcon/RP-icon.svg";
        MinTransContainer.append(MinTransIcon);

        let MinTransSmallWrapper = document.createElement("div");
        MinTransSmallWrapper.className = "RewardInfoSmallWrapper";
        MinTransContainer.append(MinTransSmallWrapper);

        let MinTransHeaderText = document.createElement("p");
        MinTransHeaderText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        MinTransHeaderText.style.color = "#797979";
        MinTransHeaderText.innerHTML =  window["MinTransaksiTxt" + window.CurrentCountryID];
        MinTransSmallWrapper.append(MinTransHeaderText);

        let MinTransInfoText = document.createElement("p");
        MinTransInfoText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        MinTransInfoText.style.marginLeft = "auto";
        MinTransSmallWrapper.append(MinTransInfoText);

        if(voucherdetails.min_transaction != null && voucherdetails.min_transaction != "" && voucherdetails.min_transaction != 0)
        {
            MinTransInfoText.innerHTML = window.ConvertTextToRP(voucherdetails.min_transaction, 1, true);
        }
        else
        {
            MinTransInfoText.innerHTML = window["NoMinimum2Txt" + window.CurrentCountryID];
        }
    }

    // Poin Terpakai ---------------------------------------------------------
    
    if(whichtype == "gift" || whichtype == "partner")
    {
        let PoinTerpakaiContainer = document.createElement("div");
        PoinTerpakaiContainer.className = "PoinWithIconWrapper PoinWithIconWrapperDetails BasicChildMargin2 InputFieldMargin4";
        VoucherInfoContainerWrapper.append(PoinTerpakaiContainer);

        let PoinTerpakaiIcon = document.createElement("img");
        PoinTerpakaiIcon.style.marginLeft = 0;
        PoinTerpakaiIcon.src = "/Assets/images/ButtonIcon/RP-icon.svg";
        PoinTerpakaiContainer.append(PoinTerpakaiIcon);

        let PoinTerpakaiSmallWrapper = document.createElement("div");
        PoinTerpakaiSmallWrapper.className = "RewardInfoSmallWrapper";
        PoinTerpakaiContainer.append(PoinTerpakaiSmallWrapper);

        let PoinTerpakaiHeaderText = document.createElement("p");
        PoinTerpakaiHeaderText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        PoinTerpakaiHeaderText.style.color = "#797979";
        PoinTerpakaiHeaderText.innerHTML =  window["PoinDeductedTxt" + window.CurrentCountryID];
        PoinTerpakaiSmallWrapper.append(PoinTerpakaiHeaderText);

        let PoinTerpakaiInfoText = document.createElement("p");
        PoinTerpakaiInfoText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        PoinTerpakaiInfoText.style.marginLeft = "auto";
        PoinTerpakaiSmallWrapper.append(PoinTerpakaiInfoText);

        if(voucherdetails.poin_deducted != null && voucherdetails.poin_deducted != "")
        {
            let PoinDeductedArray = voucherdetails.poin_deducted.split(" ");
            PoinTerpakaiInfoText.innerHTML = PoinDeductedArray[0] + " " + PoinDeductedArray[1] + " " + window["PointsTxt" + window.CurrentCountryID];
        }
        else
        {
            PoinTerpakaiInfoText.innerHTML = window["NoPoinDeductedTxt" + window.CurrentCountryID];
        }
    }


    // -------------------------------------- Voucher Code ----------------------------------

    VoucherDetailsOrangeBtn.className = "BasicTextButton OrangeButton SignInButtonTop Selectable";
    VoucherDetailsOrangeBtnContentWrapper.style.opacity = 1;

    if(whichtype == "in_app")
    {
        VoucherCodeContainer.className = "BasicRoundRadius KodeVoucherDetailsWrapper InputFieldMargin3";
        KodeVoucherHeaderText.style.opacity = 1;
        KodeVoucherKodeText.style.opacity = 1;
        KodeVoucherKodeText.innerHTML = voucherdetails.voucher_code;

        VoucherDetailsOrangeBtn.onclick = function()
        {
            window.CopyToClipboardItem(voucherdetails.voucher_code);
        }
    }
    else
    {
        let ContactUsHREF = document.createElement("a");
        ContactUsHREF.className = "HREFInsideContainer";
        ContactUsHREF.href = "/contactus/"+window.CurrentCountryID;
        VoucherDetailsOrangeBtn.append(ContactUsHREF); 
    }
}